// extracted by mini-css-extract-plugin
module.exports = {"swatch":"OptionSwatch_swatch__Sq4iH","selected":"OptionSwatch_selected__0Qmjf"};